import { api } from './api'
import { CLIENT_CODE } from '@/constants'

export type RemoteArticle = {
	id: number
	period: { start: string; end: string }
	name: string
	redirect_url: string | null
	photos: string[]
	description: string
}

export const fetchArticleList = async (params?: { page?: number; limit?: number; status?: string }) => {
	const res = await api.get<{ data: RemoteArticle[] }>('article', {
		params: {
			client_code: CLIENT_CODE,
			page: params?.page || 1,
			limit: params?.limit || 10,
			status: params?.status || 'running'
		}
	})
	return res.data.data || []
}

export const fetchArticleDetail = async (id: number) => {
	const res = await api.get<{ data: RemoteArticle }>(`article/${id}`, {
		params: { client_code: CLIENT_CODE }
	})
	return res.data.data
}

